/**
 *
 * AppBar
 *
 */

import * as React from 'react';
import { BluDeltaLogo } from 'modules/BluDeltaLogo';

// ui
import { Flex } from '@domonda/ui';

export interface AppBarProps {}

export const AppBar: React.FC<AppBarProps> = () => {
  return (
    <Flex container spacing={4} align="center">
      <Flex item>
        <BluDeltaLogo to="/" />
      </Flex>
{/*
      <Flex item>
        <MainNav />
      </Flex>
      <Flex item flex={1} />
      <Flex item>
        <MetaNav />
      </Flex>
*/}
    </Flex>
  );
};
